import { Alert, Button } from "@mui/material";
import type { AlertColor } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

export interface PageErrorStateProps {
  message: string;
  severity?: AlertColor;
  actionLabel?: string;
  onAction?: () => void;
  sx?: SxProps<Theme>;
}

export function PageErrorState({
  message,
  severity = "error",
  actionLabel,
  onAction,
  sx,
}: PageErrorStateProps) {
  return (
    <Alert
      severity={severity}
      sx={sx}
      action={
        actionLabel && onAction ? (
          <Button color="inherit" size="small" onClick={onAction}>
            {actionLabel}
          </Button>
        ) : undefined
      }
    >
      {message}
    </Alert>
  );
}
